module.exports = __webpack_public_path__ + "media/images/about/ac_1-fd7c6f2ec9153c77a11197d1030f1a28.jpg";